/**
 * convertSnakeCaseToCamelCase converts a snake case string to camel case
 * @param {string} snakeCaseString A string in snake case.
 * @returns A string in camel case.
 * @example
 *
 *   convertSnakeCaseToCamelCase('marketing_carrier_code');
 *   // returns 'marketingCarrierCode'
 */
export const convertSnakeCaseToCamelCase = (snakeCaseString) =>
  snakeCaseString.replace(/(_\w)/g, (match) => match[1].toUpperCase());
